import { useState } from 'react';
import { api } from '../api';
import { useLoad, usePolling } from '../hooks';
import { duration, itemCount, stamp, statusLabel, timeAgo } from '../format';
import { Card, Empty, ErrorNote, Loading, StatusPill, Table } from '../components/ui';
import { useNavigate } from '../router';
import type { Page, RunSummary } from '../types';

const STATUSES = ['PENDING', 'QUEUED', 'RUNNING', 'SUCCEEDED', 'FAILED', 'CANCELLED', 'TIMED_OUT'];

export function Runs() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('');
  const runs = useLoad(
    () => api.get<Page<RunSummary>>(`/v1/runs?limit=50${status ? `&status=${status}` : ''}`),
    [status],
  );
  // Çalışmalar kendi başına ilerliyor, liste operatör istemeden tazeleniyor.
  usePolling(runs.reload, 10_000);

  const rows = runs.data?.items ?? [];

  return (
    <Card
      title={`Çalışmalar${rows.length ? ` (${rows.length})` : ''}`}
      flush
      actions={
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">tüm durumlar</option>
          {STATUSES.map((value) => (
            <option key={value} value={value}>
              {statusLabel(value)}
            </option>
          ))}
        </select>
      }
    >
      {runs.error && (
        <div style={{ padding: '14px 16px 0' }}>
          <ErrorNote message={runs.error} />
        </div>
      )}
      {runs.loading && rows.length === 0 && <Loading />}
      {!runs.loading && rows.length === 0 && (
        <Empty title="Eşleşen çalışma yok">Farklı bir durum filtresi deneyebilirsin.</Empty>
      )}
      {rows.length > 0 && (
        <Table head={['Çalışma', 'Actor', 'Sürüm', 'Durum', 'Deneme', 'Öğe', 'Süre', 'Başlangıç']}>
          {rows.map((run) => (
            <tr key={run.id} className="clickable" onClick={() => navigate(`/runs/${run.id}`)}>
              <td className="mono">{run.id.slice(0, 12)}…</td>
              <td className="cell-title">{run.actorSlug}</td>
              <td className="muted mono">{run.actorVersion}</td>
              <td>
                <StatusPill status={run.status} />
              </td>
              <td className="muted">
                {run.attempt}/{run.maxAttempts}
              </td>
              <td>{itemCount(run.stats)}</td>
              <td className="muted">
                {run.startedAt && run.finishedAt
                  ? duration(new Date(run.finishedAt).getTime() - new Date(run.startedAt).getTime())
                  : '—'}
              </td>
              <td className="muted" title={stamp(run.startedAt ?? run.createdAt)}>
                {timeAgo(run.startedAt ?? run.createdAt)}
              </td>
            </tr>
          ))}
        </Table>
      )}
    </Card>
  );
}
